// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__zDDoh","title":"BackImages_title__1ISJp","images":"BackImages_images__x41lU"};